module.exports = __webpack_public_path__ + "img/chevron.5a2e2a74.svg";